import AppNavbar from "../components/AppNavbar";
import PageViewport from "../pages/PageViewport";

function RootLayout({
  currentPage,
  currentSubpage,
  pageShell,
  pageMapItems,
  primaryNavItems,
  secondaryNavItem,
  onNavigate,
  signedIn,
  children,
}) {
  return (
    <div className={`rootLayout ${signedIn ? "isSignedInMode" : "isVisitorMode"}`}>
      <div className="rootLayoutBackdrop" aria-hidden="true" />
      <AppNavbar
        currentPage={currentPage}
        onNavigate={onNavigate}
        primaryNavItems={primaryNavItems}
        secondaryNavItem={secondaryNavItem}
        signedIn={signedIn}
      />
      <main className={`rootLayoutMain ${signedIn ? "isSignedInPage" : "isVisitorPage"}`}>
        <PageViewport
          pageId={currentPage}
          subpage={currentSubpage}
          shell={pageShell}
          pageMapItems={pageMapItems}
          currentPage={currentPage}
          onNavigate={onNavigate}
        >
          {children}
        </PageViewport>
      </main>
    </div>
  );
}

export default RootLayout;
